import React from 'react';

import useStore from '@/state';
import getThirdparty from '@/state/selectors/options/get-thirdparty';

const BeforeRenderer: React.FC = () => {
	const isThirdParty = useStore(getThirdparty);
	const welcomBannerXf = document.querySelector('#welcome-banner-xf-path');
	const html = welcomBannerXf?.innerHTML;

	if (!html || !isThirdParty) return null;

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: html,
			}}
		/>
	);
};

export { BeforeRenderer };
